
import '../libs/local/easypick/index.bab.js';
// import css_picker from '../../css/libs/local/easepick.css'
// import css_picker_custom from '../../css/style/easepick.css'
// export const easepick_styles = css_picker + css_picker_custom

export function initInScope ($scope) {
    // console.log("easypick");
    // import('@easepick/bundle').then(function (flatpickr){
    //
    // });
    // console.log("CSS!!!!!!!!!!!!!!!!!!!!!");
    // console.log(easepick_styles);
    var easyPickerElementsClass = ".js-easypicker-container";
    var easyPickerElements = $(easyPickerElementsClass);
    var mobileBreakpointXs = 768;
    var mobileBreakpoint = 992;

    if(easyPickerElements.length > 0) {
        var dataLocale = easyPickerElements.first().data("locale");
        var minDays = 30;
        var lang = "de-DE";

        let rangeLocale = {
            one: 'Nacht',
            other: 'Nächte'
        }
        if(dataLocale && dataLocale != "de") {
            lang = "en-US";
            rangeLocale = {
                one: 'Night',
                other: 'Nights'
            }
        }
        var footerInfoStr = easyPickerElements.first().data("footer-info");
        footerInfoStr = footerInfoStr.replace("%minNights%", '<span class="min-nights">' + (minDays - 1) + '</span>');
        var now = Date.now();
        var today = new Date(now);
        today.setHours(0,0,0,0);
        let easePickerFormatDate = function (date, type) {
            if(!date) {
                return null;
            }

            let day = date.getDate();
            let month = date.getMonth() + 1;
            // let month = date.format("MMM", lang);
            let year = date.getFullYear();
            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            if(type === "hidden") {
                return year + '-' + month + '-' + day + "T00:00:00"; //this time shit is nescessary sadly otherwise we need to refacture the whole search and the strange date handling
            } else {
                return date.format("D. MMM. YYYY", lang);
            }
        }

        let calculateMinDateTo = function (dateFrom) {
            let tmpDate = new Date(dateFrom.getTime());
            tmpDate.setDate(tmpDate.getDate() + (minDays - 1));
            return tmpDate
        }

        let calculateMaxDateFrom = function (dateFrom) {
            let tmpDate = new Date(dateFrom.getTime());
            tmpDate.setDate(tmpDate.getDate() - (minDays - 1));
            return tmpDate
        }




        easyPickerElements.each(function () {
            var myself = $(this);
            if(myself.hasClass("initialized")) {
                return true;
            }
            myself.addClass("initialized");

            var jsEpWrapperClass = ".js-easypick-wrapper";
            var jsEpWrapper = myself.find(jsEpWrapperClass);

            var dateFromContEl = $(this).find(".easypick-from-container");
            var dateToContEl = $(this).find(".easypick-to-container");


            var dateFromEl = dateFromContEl.find(".easypick-from");
            var dateToEl = dateToContEl.find(".easypick-to");
            var nightsCont = myself.find(".nights-container");
            var nightsEl = nightsCont.find(".nights-val");
            var dateFromHiddenEl = dateFromContEl.find(".easypick-from__hidden");
            var dateToHiddenEl = dateToContEl.find(".easypick-to__hidden");

            var preSelectedFrom = dateFromHiddenEl.val() ? new Date(dateFromHiddenEl.val()) : null;
            var preSelectedTo = dateToHiddenEl.val() ? new Date(dateToHiddenEl.val()) : null;

            var dateFromCloseEl = dateFromContEl.find(".easypick-close");
            var dateToCloseEl = dateToContEl.find(".easypick-close");


            var showAllEl = $(this).find(".mobile-search-someinfo");
            var showAllElSpan = showAllEl.find("span:first");
            var showAllElPh = showAllElSpan.data("placeholder");


            var ismobile = $(this).data("ismobile") === 1;
            var bindEl = dateFromEl;
            var bindToEl = dateToEl;
            // var shadowRoot = document;
            var isInline = true;
            if(isInline) {
                bindEl = $(this).find('.js-easypicker-position');
                bindToEl = $(this).find('.js-easypicker-position-to');
            }


            let currDateFrom, currDateTo, currMinDateTo, currMaxDateFrom;
            let currDateFromString, currDateToString, currHiddenDateFromString, currHiddenDateToString;

            if(!ismobile) {
                jsEpWrapper.parents(".portal-search-desktop:first").append(jsEpWrapper);
            } else {

            }


            let clearDateFromEls = function () {
                currDateFrom = null;
                dateFromEl.val("");
                dateFromEl.trigger("change");
                dateFromHiddenEl.val("");
            }
            let setDateFromEls = function () {
                dateFromCloseEl.removeClass("hidden");
                dateFromEl.val(currDateFromString);
                dateFromEl.trigger("change");
                // let [day, month, year] = currDateFromString.split('.');
                dateFromHiddenEl.val(currHiddenDateFromString);
            }
            let clearDateToEls = function () {
                currDateTo = null;
                dateToEl.val("");
                dateToEl.trigger("change");
                dateToHiddenEl.val("");
            }
            let setDateToEls = function () {
                dateToCloseEl.removeClass("hidden");
                dateToEl.val(currDateToString);
                dateToEl.trigger("change");
                // let [day, month, year] = currDateToString.split('.');
                dateToHiddenEl.val(currHiddenDateToString);
            }
            let markFirstAvailable = function (dateFrom, picker) {
                // console.log("marking first available");
                let container = $(picker.ui.container);
                // console.log(container);
                // console.log(container.find(".day .border-radius.first-available"));
                container.find(".day .border-radius.first-available").removeClass("first-available");
                if(dateFrom) {
                    container.find('.day[data-time="'+currMinDateTo.getTime()+'"] .border-radius').addClass("first-available");
                }
            }

            let updateSomeInfo = function () {
                if(!ismobile) {
                    return;
                }
                // console.log("updating someinfo");
                let dateFromStr = dateFromEl.val();
                let dateToStr = dateToEl.val();
                if(dateFromStr && dateToStr) {
                    showAllElSpan.text(dateFromStr + " - " + dateToStr);
                } else if(dateFromStr) {
                    showAllElSpan.text(dateFromStr + " - ");
                } else {
                    showAllElSpan.text(showAllElPh);
                }
            }
            let doSelection = function (e, picker) {
                // console.log("DOING SELECTION");
                // console.log(e.detail);


                if(e.detail.start) {
                    currDateFrom = e.detail.start.clone();
                    currMinDateTo = calculateMinDateTo(currDateFrom);
                    currDateFromString = easePickerFormatDate(currDateFrom);
                    currHiddenDateFromString = easePickerFormatDate(currDateFrom, "hidden");
                }

                if(e.detail.end) {
                    currDateTo = e.detail.end.clone();
                    currMaxDateFrom = calculateMaxDateFrom(currDateTo);
                    currDateToString = easePickerFormatDate(currDateTo);
                    currHiddenDateToString = easePickerFormatDate(currDateTo, "hidden");
                }

                // console.log("-----------------------------------");
                // console.log(e.detail.start);
                // console.log(e.detail.start);
                // console.log(e.detail.end);
                // console.log(currDateFrom);
                // console.log(currDateTo);
                var gotodate = null;
                var isMinDateTo = false;

                if(currDateFrom && currDateTo) {
                    // console.log("checking mindays and applying --------------------------");
                    let applyBtn = $(picker.ui.container).find(".apply-button");
                    if(currMinDateTo.getTime() > currDateTo.getTime() || currMaxDateFrom.getTime() < currDateFrom.getTime()) {
                        // console.log("daterange invalid  --------------------------");

                        picker.clear();
                        clearDateToEls();

                        picker.setStartDate(currDateFrom);
                        setDateFromEls();

                        picker.datePicked = [picker.getStartDate()];
                        picker.renderAll();

                        dateToEl.trigger("click");
                        gotodate = picker.getStartDate();
                        if(ismobile) {
                            gotodate = calculateMinDateTo(gotodate);
                            isMinDateTo = true;
                        }
                        gotoDate(gotodate, picker, false, isMinDateTo);

                        nightsCont.hide();
                        updateSomeInfo();
                        return;
                    } else {
                        // console.log("daterange valid  --------------------------");
                        picker.setDateRange(currDateFrom, currDateTo);

                        //mark in range els then reset datePicked to allow selection inside usually blocked dates (cuz of minDate)
                        picker.datePicked = [picker.getStartDate(), picker.getEndDate()];
                        picker.renderAll();
                        picker.datePicked = [];
                        picker.renderAll();

                        nightsEl.text(picker.getEndDate().diff(picker.getStartDate()))
                        nightsCont.show();
                    }
                }
                // console.log("currDateFrom befor mark");
                // console.log(currDateFrom);
                markFirstAvailable(currDateFrom, picker);

                if(e.detail.start) {
                    setDateFromEls();
                }
                if(e.detail.end) {
                    setDateToEls();
                }

                if (currDateFrom && currDateTo) {
                    dateFromEl.trigger("focus");
                } else if (currDateFrom && !currDateTo) {
                    picker.setStartDate(currDateFrom);
                    gotodate = currDateFrom;
                    if (ismobile) {
                        gotodate = calculateMinDateTo(gotodate);
                        isMinDateTo = true;
                    }
                    if(!e.detail.omitGotoDate) {
                        gotoDate(gotodate, picker, false, isMinDateTo);
                    }
                    dateToEl.trigger("click");
                }

                updateSomeInfo();

            }

            let gotoDate = function(date, picker, isEnd = false, isMinDateTo = false) {
                // console.log("------------- gotodate -------------");
                if(ismobile) {
                    let jumpEl = null;
                    if(isMinDateTo) {
                        jumpEl = $(picker.ui.container).find(".day .first-available");
                    } else if(!isEnd) {
                        jumpEl = $(picker.ui.container).find(".day.start");
                        // console.log("seeking start");
                    } else {
                        jumpEl = $(picker.ui.container).find(".day.end");
                        // console.log("seeking end");
                    }

                    if(jumpEl.length > 0) {
                        $(".portal-search-mobile-pullup").animate({ scrollTop: $(".portal-search-mobile-pullup").scrollTop() + jumpEl.offset().top - 220}, 500);

                        // console.log(jumpEl);
                        // console.log(jumpEl.offset().top);
                        // console.log($(".portal-search-mobile-pullup").scrollTop());
                    } else {
                        easypicker.gotoDate(date);
                        // $(".portal-search-mobile-pullup").scrollTop(0); //gotta because the pullup is outside the wrappers
                        $(".portal-search-mobile-pullup").animate({ scrollTop: 0 }, 500); //gotta because the pullup is outside the wrappers
                    }

                } else {
                    easypicker.gotoDate(date);
                }
                // console.log("------------- gotodate end -------------");
            }
            var calendarsNr = 2;
            var gridNr = 2;
            if(ismobile) {
                if(screen.width >= mobileBreakpointXs) {
                    calendarsNr = 6;
                    gridNr = 2;
                } else {
                    calendarsNr = 6;
                    gridNr = 1;
                }

            }
            var easypicker = new easepick.create({
                // doc: shadowRoot,
                element: bindEl[0],
                plugins: [
                    "RangePlugin",
                    "LockPlugin"
                ],
                LockPlugin: {
                    minDays: minDays,
                    maxDays: 365,
                    minDate: "2024-07-16T00:00:00.000Z"
                },
                RangePlugin: {
                    strict: false,
                    repick: true,
                    elementEnd: bindToEl[0],
                    tooltipNumber: function (nr) {
                        return nr - 1;
                    },
                    // startDate: preSelectedFrom ? preSelectedFrom.getTime() : null, //disable for now
                    // endDate: preSelectedTo ? preSelectedTo.getTime() : null,
                    locale: rangeLocale
                },
                lang: lang,
                // locale: {
                //     nextMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16"><path fill="#323232" d="M12.5,14.7143258 L19.0516073,8.16271845 C19.2685653,7.94576052 19.6203236,7.94576052 19.8372815,8.16271845 C20.0542395,8.37967639 20.0542395,8.73143472 19.8372815,8.94839266 L12.8928371,15.8928371 C12.6758792,16.109795 12.3241208,16.109795 12.1071629,15.8928371 L5.16271845,8.94839266 C4.94576052,8.73143472 4.94576052,8.37967639 5.16271845,8.16271845 C5.37967639,7.94576052 5.73143472,7.94576052 5.94839266,8.16271845 L12.5,14.7143258 Z" transform="rotate(-90 6.5 14.028)"/></svg>',
                //     previousMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16"><path fill="#323232" d="M12.5,14.7143258 L19.0516073,8.16271845 C19.2685653,7.94576052 19.6203236,7.94576052 19.8372815,8.16271845 C20.0542395,8.37967639 20.0542395,8.73143472 19.8372815,8.94839266 L12.8928371,15.8928371 C12.6758792,16.109795 12.3241208,16.109795 12.1071629,15.8928371 L5.16271845,8.94839266 C4.94576052,8.73143472 4.94576052,8.37967639 5.16271845,8.16271845 C5.37967639,7.94576052 5.73143472,7.94576052 5.94839266,8.16271845 L12.5,14.7143258 Z" transform="rotate(-90 6.5 14.028)"/></svg>'
                // },
                format: "DD.MMM.YYYY",
                calendars: calendarsNr,
                grid: gridNr,
                zIndex: 100,
                inline: isInline,
                autoApply: false,
                css: [
                    '/static/css/libs/local/easepick.css' + "?" + now,
                    '/static/css/style/easepick-add.min.css' + "?" + now
                    // '/static/css/style/easepick.css' + "?" + now,
                ],
                setup(easypicker) {
                    // console.log("EP: setup");
                    // console.log(easypicker);

                    easypicker.on("render", function (e) {
                        if(!ismobile) {
                            let footerEl = $(easypicker.ui.container).find("footer");
                            let footerInfoEl = footerEl.find(".footer-info");
                            if(footerInfoEl.length <= 0) {
                                footerEl.append('<div class="footer-info">' + footerInfoStr + '</div>');
                            }
                        }
                        $(e.target).find(".day").each(function () {
                            var addClasses = "";
                            if($(this).data("time") < today.getTime()) {
                                // console.log("setting past day");
                                addClasses = addClasses + " past-day";
                            }
                            var tmpHtml = $(this).text();
                            $(this).html('<div class="border-radius ' + addClasses + '">' + tmpHtml + '</div>');
                        });
                        markFirstAvailable(currDateFrom, easypicker);
                    });
                    // if(!ismobile) {
                    //     easypicker.on("view", function (e) {
                    //         if(e.detail.view === "CalendarFooter") {
                    //             console.log("EP: view CalendarFooter");
                    //             console.log(e.detail);
                    //             let footerEl = $(e.detail.target);
                    //             footerEl.append("<span>TEST123</span>");
                    //         }
                    //     });
                    // }

                    easypicker.on("preselect", function (e) {
                        // console.log("EP: PRESELECTED");
                        // console.log(e.detail);
                        // console.log(easypicker.datePicked);

                        easypicker.PluginManager.instances.RangePlugin.triggerElement = undefined;

                        doSelection(e, easypicker);


                        // // console.log(easypicker);
                        // console.log(this);
                        // tmpDate.setDate(tmpDate.getDate() + (easypicker.options.LockPlugin.minDays - 1));
                        // console.log(tmpDate);
                        // console.log(tmpDate.getTime());
                        // $(this).find(".first-available").removeClass("first-available");
                        // console.log("FINDING SPCIFIC DAY EL");
                        // console.log($(this).find('.day[data-time="'+tmpDate.getTime()+'"]'));
                        // $(this).find('.day[data-time="'+tmpDate.getTime()+'"]').addClass("first-available");
                    });
                    easypicker.on("select", function (e) {
                        // console.log("EP: SELECTED");
                        // console.log(e);
                        // console.log(easypicker);
                        // console.log(e.detail);
                        if(ismobile) {
                            //doSelection(e, easypicker);
                        }
                        // doSelection(e, easypicker);

                    });

                    // let epWrapper = jsEpWrapper.find(".easepick-wrapper");
                    if(!ismobile) {
                        // dateFromEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateToEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateFromCloseEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateToCloseEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });

                        $(document).on("click", function (e) {
                            if($(e.target).closest(easyPickerElementsClass).length === 0 && $(e.target).closest(".easepick-wrapper").length === 0) {
                                jsEpWrapper.hide();
                            }
                        });
                    }
                    //we leave stop propagation here as the bind elements are hidden anyways. we need it because otherwise stuff will be closed
                    bindEl.on("click", function (e) {
                        // console.log("clicked on bindEL");
                        e.stopPropagation();
                    });
                    bindToEl.on("click", function (e) {
                        e.stopPropagation();
                    });
                    //make sure the picker jumps to the right month
                    dateFromEl.on("click", function (e) {
                        if(!ismobile) {
                            // console.log("showing wrapper");
                            jsEpWrapper.show();
                        }
                        // console.log("easypicker.datePicked");
                        // console.log(easypicker.datePicked);
                        if(currDateFrom) {
                            gotoDate(currDateFrom, easypicker, false);
                        }

                        // console.log("SOMEINFOS From");
                        // console.log(currDateFrom);
                        // console.log(currDateTo);

                        // console.log("trigger from click and setting el");
                        // console.log(dateFromEl);
                        // console.log(bindEl);
                        easypicker.PluginManager.instances.RangePlugin.triggerElement = bindEl[0];
                        bindEl.trigger("click");
                        $(this).trigger("focus");
                    });
                    // dateToEl.on("touchstart", function (e) {
                    //     console.log("touchstart preventing dflt");
                    //     e.preventDefault();
                    // });
                    dateToEl.on("click", function (e) {
                        // console.log("triggered dateToEl Click");
                        e.preventDefault();
                        if(!ismobile) {
                            // console.log("showing wrapper");
                            jsEpWrapper.show();
                        }
                        // console.log("easypicker.datePicked");
                        // console.log(easypicker.datePicked);
                        if(currDateTo) {
                            gotoDate(currDateTo, easypicker, true);
                        }

                        //check if we need the click event
                        // console.log("SOMEINFOS To");
                        // console.log(currDateFrom);
                        // console.log(currDateTo);

                        // console.log("trigger to click and setting el");

                        easypicker.PluginManager.instances.RangePlugin.triggerElement = bindToEl[0];

                        bindToEl.trigger("click");
                        $(this).trigger("focus");
                    });
                    //check for preselection
                    if(preSelectedFrom && preSelectedTo && false) { //disable for now
                        // console.log("Preselecteing");
                        // var dummyDate = easypicker.getStartDate().clone();
                        // dummyDate.setTime(preSelectedFrom);
                        // console.log(easypicker.getStartDate());
                        // console.log(easypicker.getEndDate());
                        var dummyEFrom = {
                            start: easypicker.getStartDate(),
                            omitGotoDate: true
                        };
                        // doSelection(dummyE, preSelectedFrom);
                        easypicker.trigger("preselect", dummyEFrom);
                        var dummyETo = {
                            start: easypicker.getStartDate(),
                            end: easypicker.getEndDate(),
                            omitGotoDate: true
                        };
                        easypicker.trigger("preselect", dummyETo);

                        jsEpWrapper.hide();
                        // doSelection(dummyE, preSelectedTo);
                    }
                }
            });

            dateFromCloseEl.on("click", function (e) {
                easypicker.clear();
                nightsCont.hide();
                dateFromHiddenEl.val("");
                dateFromEl.val("");
                currDateFrom = null;

                dateToHiddenEl.val("");
                dateToEl.val("");
                currDateTo = null;

                $(this).addClass("hidden");
                dateToCloseEl.addClass("hidden");
                dateFromEl.trigger("click");
                updateSomeInfo();
            });
            dateToCloseEl.on("click", function (e) {
                var startDate = easypicker.getStartDate();
                nightsCont.hide();
                // easypicker.clear();
                // dateFromHiddenEl.val("");
                dateToHiddenEl.val("");
                dateToEl.val("");
                currDateTo = null;
                if(startDate) {
                    // console.log("setting startDate");
                    // console.log(startDate);
                    // easypicker.setDateRange([startDate, null]);
                    easypicker.clear();
                    easypicker.setStartDate(startDate);
                    // easypicker.setEndDate(false);
                    // console.log(easypicker.getStartDate());
                    // console.log(easypicker.getEndDate());
                    // easypicker.setDateRange([startDate]);
                    // let applyBtn = $(easypicker.ui.container).find(".apply-button");
                    // applyBtn.trigger("click"); //force apply
                    dateToEl.trigger("click");
                } else {
                    dateFromEl.trigger("click");
                }

                $(this).addClass("hidden");
                updateSomeInfo();
            });


            // console.log("EASYPICKER");
            // console.log(easypicker);
            // console.log(easypicker.PluginManager);
            // console.log(easypicker.PluginManager.instances);
            // easypicker.on("view", function (e) {
            //     console.log("TEST123 ONVIEW");
            //     console.log(e.detail);
            // });
            // easypicker.on("render", function () {
            //     // console.log("TEST123 render");
            // });

        //
        });

    }




}
